export const DELIVERY_KITCHEN = {
  GET_DELIVERY_KITCHEN: "GET_DELIVERY_KITCHEN",
  LOADING_GET_DELIVERY_KITCHEN: "LOADING_GET_DELIVERY_KITCHEN",
  LOADING_POST_DELIVERY_KITCHEN: "LOADING_POS_DELIVERY_KITCHEN",
};
